import { css, RuleSet } from 'styled-components'
import { ResponsiveClassNameGetter } from './createResponsiveClassNameGetter'

function getResponsiveStyles<Value extends string | number>(
  responsiveClassNameGetter: ResponsiveClassNameGetter<Value>,
  styleDefinitions: Record<Value, RuleSet<object>>,
): {
  mobile: RuleSet<object>,
  tablet: RuleSet<object>,
  desktop: RuleSet<object>,
  largeDesktop: RuleSet<object>,
  extraLargeDesktop: RuleSet<object>,
} {
  const mobile = Object.entries<RuleSet<object>>(styleDefinitions).map(([value, style]) => css`
    &.${responsiveClassNameGetter({ mobile: value as Value })} {
      ${style}
    }
  `)
  const tablet = Object.entries<RuleSet<object>>(styleDefinitions).map(([value, style]) => css`
    &.${responsiveClassNameGetter({ tablet: value as Value })} {
      ${style}
    }
  `)
  const desktop = Object.entries<RuleSet<object>>(styleDefinitions).map(([value, style]) => css`
    &.${responsiveClassNameGetter({ desktop: value as Value })} {
      ${style}
    }
  `)
  const largeDesktop = Object.entries<RuleSet<object>>(styleDefinitions).map(([value, style]) => css`
    &.${responsiveClassNameGetter({ largeDesktop: value as Value })} {
      ${style}
    }
  `)
  const extraLargeDesktop = Object.entries<RuleSet<object>>(styleDefinitions).map(([value, style]) => css`
    &.${responsiveClassNameGetter({ extraLargeDesktop: value as Value })} {
      ${style}
    }
  `)
  return { mobile, tablet, desktop, largeDesktop, extraLargeDesktop }
}

export default getResponsiveStyles
